import { render, staticRenderFns } from "./a-product-rating.vue?vue&type=template&id=0d18c1db&scoped=true&"
import script from "./a-product-rating.vue?vue&type=script&lang=js&"
export * from "./a-product-rating.vue?vue&type=script&lang=js&"
import style0 from "./a-product-rating.vue?vue&type=style&index=0&id=0d18c1db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18c1db",
  null
  
)

export default component.exports